// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.reviews.HpApiApartmentReviewsV3Handler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { HpApartmentReviewsRequestDto, HpApartmentReviewsResponseDto, HpApiResponseDto } from '../..';

export const HpApiApartmentReviewsV3Handler_apartmentReviews_Path = '/api/v3/apartmentReviews';

/**
 * Returns available third-party apartment reviews and schedules Google Place resolution
 */
export const HpApiApartmentReviewsV3Handler_apartmentReviews = (
  postData: HpApartmentReviewsRequestDto,
  client = getClient(),
) => {
  return httpApiRequest<never, HpApartmentReviewsRequestDto, HpApiResponseDto<HpApartmentReviewsResponseDto>>(
    {
      endpoint: HpApiApartmentReviewsV3Handler_apartmentReviews_Path,
      method: 'POST',
      contextPath: '/hotpads-api',
      postData: postData,
    },
    client,
  );
};
